import { ScreenStateContextProvider } from "./contexts/ScreenStateContextProvider";
import { SelectedDeviceContextProvider } from "./contexts/SelectedDeviceContextProvider";
import { ActionContextProvider } from "./contexts/ActionContextProvider";
import TfaVerifyContainer from "./TfaVerifyContainer";

const TfaVerify = ({
  totalSteps,
  step,
  cancelAction,
  goToReview,
}: {
  totalSteps?: number;
  step?: number;
  cancelAction?: () => void;
  goToReview?: () => void;
}) => (
  <ScreenStateContextProvider>
    <SelectedDeviceContextProvider>
      <ActionContextProvider
        cancelAction={cancelAction}
        goToReview={goToReview}
      >
        <div className="sudo-mode-container">
          <TfaVerifyContainer totalSteps={totalSteps} step={step} />
        </div>
      </ActionContextProvider>
    </SelectedDeviceContextProvider>
  </ScreenStateContextProvider>
);

export default TfaVerify;
